import { request } from '~/components/Instance';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

export const loadTaskGrid = (task_id, date, customersById, setLoading, setCustomers) => {
  const formattedDate = moment(date).format('YYYY-MM-DD');
  setLoading(true);
  request('get', `/calendar/task/${task_id}/grid/${formattedDate}`, {}, false)
    .then((response) => {
      const customerData = response.data.map((item) => ({
        ...item,
        customer: customersById[item.customer_id],
      }));
      setCustomers(customerData);
    })
    .catch((error) => {
      console.error('Error loading task grid:', error);
      // You might want to show an error notification here
    })
    .finally(() => {
      setLoading(false);
    });
};

export const changeStatus = (record_task_id, status, setCustomers) => {
  request('patch', `/calendar/task_record/${record_task_id}/status/${status}`)
    .then((response) => {
      setCustomers((prevCustomers) =>
        prevCustomers.map((row) =>
          row.customer_id !== response.data.data.customer_id
            ? row
            : {
                ...row,
                months: {
                  ...row.months,
                  [Object.keys(row.months).find((index) => row.months[index] && row.months[index].id === record_task_id)]: response.data.data,
                },
              }
        )
      );
    })
    .catch((error) => {
      console.error('Error changing status:', error);
      // You might want to show an error notification here
    });
};

export const createTaskRecordAndUpdateStatus = (data, setCustomers) => {
  request('post', '/calendar/task_record/create', data)
    .then((response) => {
      setCustomers((prevCustomers) =>
        prevCustomers.map((currentCustomer) =>
          currentCustomer.customer_id !== response.data.data.customer_id
            ? currentCustomer
            : {
                ...currentCustomer,
                months: {
                  ...currentCustomer.months,
                  [Object.keys(currentCustomer.months).find(
                    (month) => currentCustomer.months[month] && currentCustomer.months[month].due_date === data.due_date.slice(0, 7)
                  )]: response.data.data,
                },
              }
        )
      );
    })
    .catch((error) => {
      console.error('Error creating task record:', error);
      // You might want to show an error notification here
    });
};

export const addComment = (record_task_id, comment, setCustomers) => {
  if (!record_task_id || !comment) {
    console.error('Invalid parameters:', { record_task_id, comment });
    return Promise.reject(new Error('Parâmetros inválidos para adicionar comentário'));
  }

  return new Promise((resolve, reject) => {
    // Get the current customer data to find the record_task
    setCustomers((prevCustomers) => {
      const updatedCustomers = prevCustomers.map((row) => {
        // Find the month that contains this record_task
        const monthKey = Object.keys(row.months).find(
          (index) => row.months[index] && row.months[index].id === record_task_id
        );

        if (!monthKey) return row;

        const currentComments = row.months[monthKey].comments || [];
        
        const requestData = {
          comments: [
            ...currentComments,
            {
              comment: comment,
              created_at: new Date().toISOString(),
              uid: uuid()
            }
          ]
        };

        // Make the API call
        request('post', `/calendar/task_record/${record_task_id}/comment`, requestData, false)
          .then((response) => {
            // Update the state with the new comments
            setCustomers((prev) =>
              prev.map((customer) =>
                customer.customer_id !== response.data.data.customer_id
                  ? customer
                  : {
                      ...customer,
                      months: {
                        ...customer.months,
                        [monthKey]: {
                          ...customer.months[monthKey],
                          comments: response.data.data.comments,
                        },
                      },
                    }
              )
            );
            resolve(response.data.data.comments);
          })
          .catch((error) => {
            console.error('Error adding comment:', error);
            reject(error);
          });

        return row;
      });

      return updatedCustomers;
    });
  });
};

export const createTaskRecordAndComment = (comment, customer_id, record_task, monthIndex, data, setCustomers) => {
  // Validate all required data
  if (!data || !data.due_date) {
    console.error('Invalid task data:', data);
    return Promise.reject(new Error('Dados da tarefa inválidos'));
  }

  if (!record_task || !record_task.due_date) {
    console.error('Invalid record_task data:', record_task);
    return Promise.reject(new Error('Dados do registro inválidos'));
  }

  if (!record_task.customer_id) {
    console.error('Invalid customer_id:', record_task);
    return Promise.reject(new Error('Dados do cliente inválidos'));
  }

  if (typeof monthIndex !== 'number') {
    console.error('Invalid month index:', monthIndex);
    return Promise.reject(new Error('Mês inválido'));
  }

  try {
    const recordDueDate = record_task.due_date.slice(0, 7); // Get YYYY-MM
    const taskDueDay = data.due_date.split('-')[2];
    
    const requestData = {
      task_id: data.id,
      customer_id: record_task.customer_id,
      due_date: `${recordDueDate}-${taskDueDay}`,
      status: 'pending',
      comments: [{
        comment: comment,
        created_at: new Date().toISOString(),
        uid: uuid()
      }]
    };

    return request('post', '/calendar/task_record/create', requestData)
      .then((response) => {
        setCustomers((prevCustomers) =>
          prevCustomers.map((currentCustomer) =>
            currentCustomer.customer_id !== response.data.data.customer_id
              ? currentCustomer
              : {
                  ...currentCustomer,
                  months: {
                    ...currentCustomer.months,
                    [Object.keys(currentCustomer.months).find(
                      (month) => currentCustomer.months[month] && currentCustomer.months[month].due_date === requestData.due_date.slice(0, 7)
                    )]: response.data.data,
                  },
                }
          )
        );
        return response.data.data.comments;
      })
      .catch((error) => {
        console.error('Error creating task record with comment:', error);
        throw error;
      });
  } catch (error) {
    console.error('Error processing task record data:', error);
    return Promise.reject(new Error('Erro ao processar os dados do registro'));
  }
};

export const changeStatusAll = (status, month, data, date, setLoading, loadTaskGrid, customersById, setCustomers) => {
  if (!data) return;
  const [monthFormatted, year] = moment(date).format('MM-YYYY').split('-');
  setLoading(true);
  request('patch', `/calendar/task/${data.id}/status`, { status, month, year })
    .then(() => {
      loadTaskGrid(data.id, date, customersById, setLoading, setCustomers);
    })
    .catch((error) => {
      console.error('Error changing status for all:', error);
      setLoading(false);
      // You might want to show an error notification here
    });
};

export const removeComment = (commentToRemove, customers, setCustomers) => {
  return new Promise((resolve, reject) => {
    // Find the customer and month that contains this comment
    const customer = customers.find((customer) => {
      return Object.values(customer.months).some((month) => {
        return month.comments && month.comments.some((comment) => 
          comment.uid === commentToRemove.uid
        );
      });
    });

    if (!customer) {
      reject(new Error('Cliente não encontrado'));
      return;
    }

    // Find the month that contains this comment
    const monthKey = Object.keys(customer.months).find((index) => {
      const month = customer.months[index];
      return month.comments && month.comments.some((comment) => 
        comment.uid === commentToRemove.uid
      );
    });

    if (!monthKey) {
      reject(new Error('Mês não encontrado'));
      return;
    }

    const recordTaskId = customer.months[monthKey].id;
    const currentComments = customer.months[monthKey].comments || [];
    const updatedComments = currentComments.filter(comment => 
      comment.uid !== commentToRemove.uid
    );

    const requestData = {
      comments: updatedComments
    };

    // Make the API call to update the task record with the new comments array
    request('post', `/calendar/task_record/${recordTaskId}/comment`, requestData, false)
      .then((response) => {
        // Update the customers state
        setCustomers((prevCustomers) =>
          prevCustomers.map((customer) =>
            customer.customer_id !== response.data.data.customer_id
              ? customer
              : {
                  ...customer,
                  months: {
                    ...customer.months,
                    [monthKey]: {
                      ...customer.months[monthKey],
                      comments: response.data.data.comments,
                    },
                  },
                }
          )
        );
        resolve(response.data.data.comments);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
